export function isDefined(value) {
    return value !== undefined && value !== null;
}
